export * from './comp'

import { type, getValue, setValue, forin, extend, string2hex, eventify } from './utils'
export const Utils = { type, getValue, setValue, forin, extend, string2hex, eventify }
